import React from 'react';
import Particle from './../Particle';
import {Title} from './../Basics';

const ParticleInstance = ({isExpanded, content, keepTitle}) => {
  const WithParticles = content.particle;
  const WithoutParticles = content.particle().props.children
  .filter((child,i)=>{
    const notFirstTitle = i !== 0 && child.type !== Title 
    return keepTitle || notFirstTitle;
  })
  .map((child,i) => {
    const isParticle = child.type === Particle; // https://github.com/facebook/react/issues/4915
    // TODO ideally, well not really ideally, but anyway: To preserve the content height, 
    // we'd need the option to return either null or a collapsed .Particle div with teaser.
    const modifiedChild = isParticle ? null : child; 
    return modifiedChild ;
  });
  return isExpanded
    ? <WithParticles/>
    : <div>{WithoutParticles}</div>;
}


export default ParticleInstance;



/** WEBPACK FOOTER **
 ** ./src/Particles/ParticleInstance.js
 **/